<div class="testTitle">
  <p>規約テスト</p>
  <button id="ssn-test-agreement1" class="testButton" (click)="agreement()">表示</button>
  <button id="ssn-test-agreement2" class="testButton" (click)="agreementApf()">APF表示</button>
  <button id="ssn-test-agreement2-2" class="testButton" (click)="agreementBiz()">プランANABiz日本オフィス</button>
  <button id="ssn-test-agreement2-3" class="testButton" (click)="agreementBiz('TYONH08BZ','TYONH08AA')">
    プラン日本オフィス ANABiz
  </button>
  <button id="ssn-test-agreement3" class="testButton" (click)="agreementBack()">表示(プランリストに戻る)</button>
  <button id="ssn-test-agreement4" class="testButton" (click)="agreement('cn')">言語=日本語英語第３言語以外</button>
  <button id="ssn-test-agreement5" class="testButton" (click)="agreement('ja')">言語=日本語</button>
  <button id="ssn-test-agreement6" class="testButton" (click)="agreement('en')">言語=英語</button>
  <button id="ssn-test-agreement7" class="testButton" (click)="agreement('de')">言語=第３言語</button>
</div>
